import { inject, Injectable } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { AbookConfirmDialogComponent } from './abook-confirm-dialog/abook-confirm-dialog.component';
import { AbookConfirmOptions, AbookDialogConfig } from './abook-dialog.models';

@Injectable({
  providedIn: 'root',
})
export class AbookDialogService {
  private dialog = inject(MatDialog);

  /**
   * Show a simple confirmation dialog with title, message, and two buttons
   * @returns Promise<boolean> - true if confirmed, false if cancelled
   */
  async confirm(options: AbookConfirmOptions): Promise<boolean> {
    const dialogRef = this.dialog.open(AbookConfirmDialogComponent, {
      width: '400px',
      maxWidth: '95vw',
      data: options,
    });

    return firstValueFrom(dialogRef.afterClosed()).then((result) => !!result);
  }

  /**
   * Open a custom dialog component for advanced use cases
   * @param component The component to display inside the dialog
   * @param config Optional configuration (data, width)
   * @returns MatDialogRef for manual handling
   */
  openDialog<T, R = unknown>(component: ComponentType<T>, config?: AbookDialogConfig): MatDialogRef<T, R> {
    return this.dialog.open(component, {
      width: config?.width || '400px',
      maxWidth: '95vw',
      data: config?.data,
    });
  }
}
